module.exports = __webpack_public_path__ + "static/media/6.1d41646c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/九宫格选中态/6.png
// module id = 954
// module chunks = 0